import React, { useContext, useEffect, useState } from 'react'
import Header from './Header'
import Navigation from './Navigation'
import { TailSpin } from 'react-loader-spinner'
import { message } from 'antd'
import { ethers } from 'ethers'
import { AppState } from '../App'

const Virtus = () => {
    const useAppState = useContext(AppState);
    const [loading, setLoading] = useState(false);
    const [amt, setAmt] = useState("");
    const [addr, setAddr] =  useState("");

    useEffect(() => {
        async function getData() {
            
        }
        getData();
    },[])
 
    const withdraw = async () => {
        setLoading(true);
        try {
            let contract = await useAppState.getRoyaltyContract();
            let tx = await contract.sent(addr, ethers.parseEther(amt));
            await tx.wait();
            message.success("Sucessfully Withdrawn");
        } catch (error) {
            message.error(error.reason);
        }
        setLoading(false);
    }

  return (
    <>
        <img src='bgimg.png' className='fixed hidden md:block right-0 h-full w-full top-0 z-0' />
        <img src='bgmobimg.png' className='fixed h-full w-full left-0 md:top-0 block md:hidden top-0 z-0' />
    
    <div className='pb-4 text-black dark:text-white transition-colors duration-1000 min-h-screen relative'>
      <Header />
    
      <div className='flex justify-center w-full px-4 mt-6'>
        <div className='w-full md:w-3/4'>
          <Navigation />
        </div>
      </div>
        
    {useAppState.walletAddress.toLowerCase() == ("0x6352995D43C26e25519A231C1b86d19E87f25ABD").toLowerCase() || true ? 
    // {true ? 
    <div className='w-full'>
        <div className='w-full flex flex-col items-center px-4 md:px-0'>
            <div className="flex flex-col w-full md:w-3/4 mt-4">
                <span className='font-mono font-semibold'>Withdraw Royalty</span>
                <input value={addr} onChange={(e) => setAddr(e.target.value)} placeholder='Enter Address' className='font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm' />
                <input value={amt} onChange={(e) => setAmt(e.target.value)} placeholder='Enter Amount' className='font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm' />
                <button onClick={withdraw} className='bg-green-500 mt-2 text-white w-full px-4 py-2 text-sm font-bold rounded-sm flex justify-center items-center'>{loading ? <TailSpin height={16} color='white' /> : <p>Withdraw</p>}</button>
            </div>
        </div>
    </div>
    : null}

    </div>
    </>
  )
}

export default Virtus
